module.exports = __webpack_public_path__ + "static/media/dashboard-ads.766c0f49.png";